import React from "react";

function SlaReportStaticRows({ title, subTitle, item, labels, keys, rowSpan = 5, className = "" }) {
    const rowClass = className || undefined;

    return (
        <>
            <tr className={rowClass}>
                {subTitle ? (
                    <>
                        <th className="fieldset-th-sla" rowSpan={rowSpan}>{title}</th>
                        <th className="fieldset-th-sla" rowSpan={rowSpan}>{subTitle}</th>
                    </>
                ) : (
                    <th className="fieldset-th-sla" rowSpan={rowSpan} colSpan={subTitle ? 1 : 2}>{title}</th>
                )}
                <th className="fieldset-th-sla">가중치</th>
                <td className="fieldset-td-sla">{item.weight || 0} %</td>
            </tr>
            {labels.map((label, idx) => (
                <tr key={idx} className={rowClass}>
                    <th className="fieldset-th-sla">{label}</th>
                    <td className="fieldset-td-sla">{item[keys[idx]] || 0}</td>
                </tr>
            ))}
            <tr className={rowClass}>
                <th className="fieldset-th-sla">평가점수</th>
                <td className="fieldset-td-sla">{item.evaluationScore || 0} %</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">환산점수</th>
                <td className="fieldset-td-sla">{item.convertedScore || 0} %</td>
            </tr>
        </>
    );
}

export default SlaReportStaticRows